import { getExpiredMembershipApi } from "api/membership";
import * as S from "../../style";
import { useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ReactComponent as DownIcon } from "assets/icons/arrow-down.svg";
import { ReactComponent as UpIcon } from "assets/icons/arrow-up.svg";

const MembershipItem = ({ brand }: any) => {
  const [showMorePremium, setShowMorePremium] = useState(false);
  const [showMoreNormal, setShowMoreNormal] = useState(false);

  const toggleShowMorePremium = () => setShowMorePremium(!showMorePremium);
  const toggleShowMoreNormal = () => setShowMoreNormal(!showMoreNormal);

  return (
    <div className="membership-item">
      <div className="wr-image">
        <img src={brand.logoImage} alt={brand.brandName} />
      </div>
      <div className="wr-text">
        <h2>{brand.brandName}</h2>
        <div className="membership-list">
          {brand.premiumMembership.length > 0 && (
            <>
              <span className="label">Premium</span>
              <ul>
                {(showMorePremium
                  ? brand.premiumMembership
                  : brand.premiumMembership.slice(0, 3)
                ).map((item: any, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              {brand.premiumMembership.length > 3 && (
                <button
                  className="show-hidden-btn"
                  onClick={toggleShowMorePremium}
                >
                  {showMorePremium ? (
                    <span>
                      Show Less
                      <UpIcon />
                    </span>
                  ) : (
                    <span>
                      Show More <DownIcon />
                    </span>
                  )}
                </button>
              )}
            </>
          )}
        </div>

        <div className="membership-list">
          {brand.normalMembership.length > 0 && (
            <>
              <span className="label">Normal</span>
              <ul>
                {(showMoreNormal
                  ? brand.normalMembership
                  : brand.normalMembership.slice(0, 3)
                ).map((item: any, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              {brand.normalMembership.length > 3 && (
                <button
                  className="show-hidden-btn"
                  onClick={toggleShowMoreNormal}
                >
                  {showMoreNormal ? (
                    <span>
                      Show Less
                      <UpIcon />
                    </span>
                  ) : (
                    <span>
                      Show More <DownIcon />
                    </span>
                  )}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const Expired: React.FC = () => {
  const { userId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [membershipExpire, setMembershipExpire] = useState<any>([]);

  const getExpiredMembership = async () => {
    if (!userId) {
      return;
    }
    const { data, error }: any = await getExpiredMembershipApi({
      userId: +userId,
    });
    if (error) {
      console.error(error);
      return;
    }
    const formattedData: any = [];

    data.membership.forEach((item: any) => {
      if (
        item.premiumMembership.length > 0 &&
        item.normalMembership.length > 0
      ) {
        formattedData.push({
          brandId: item.brandId,
          brandName: item.brandName,
          logoImage: item.logoImage,
          premiumMembership: item.premiumMembership,
          normalMembership: [],
        });
        formattedData.push({
          brandId: item.brandId,
          brandName: item.brandName,
          logoImage: item.logoImage,
          premiumMembership: [],
          normalMembership: item.normalMembership,
        });
      } else {
        formattedData.push(item);
      }
    });
    setMembershipExpire(formattedData);
  };

  useEffect(() => {
    if (searchParams.get("joinTab") === "expired") {
      getExpiredMembership();
    }
  }, []);
  // console.log("subExpire", membershipExpire);

  return (
    <S.Expired>
      {membershipExpire.length > 0 ? (
        <S.BrandJoinInner>
          {membershipExpire?.map((brand: any, index: number) => (
            <MembershipItem key={index} brand={brand} />
          ))}
        </S.BrandJoinInner>
      ) : (
        <div className="no-data">No Data</div>
      )}
    </S.Expired>
  );
};

export default Expired;
